import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicTable, TableFilter, EmptyState, BaasicButton, QueryDropdown, BasicQueryInput, BasicQueryCheckbox } from 'core/components';
import EmptyIcon from 'themes/assets/img/building-modern.svg';
import { ApplicationListLayout, Content, PageNavigation } from 'core/layouts';
import { isSome } from 'core/utils';

function ProductListTemplate({ listViewStore }) {
    const {
        tableLoading,
        tableStore,
        queryUtility,
        itemCategoryStore,
        itemIdStore,
        itemNameStore,
        procedureCodeStore,
        authorization,
        inactiveCheckboxStore,
        oninactiveChange,
        showPumpsCheckboxStore,
        onShowPumpsChange,
        routes,
        downloadUrl
    } = listViewStore;

    return (
        <ApplicationListLayout store={listViewStore}>
            <PageNavigation>
                <BaasicButton className="btn btn--base btn--primary" label={'Download'} icon='u-icon u-icon--sml u-icon--download--white' onClick={() => { window.open(downloadUrl, "_blank"); }}></BaasicButton>
                <BaasicButton authorized={authorization ? authorization.update : true} className="btn btn--base btn--primary" label={'Upload'} icon='u-icon u-icon--sml u-icon--upload--white' onClick={() => { routes.upload() }}></BaasicButton>
                <BaasicButton authorized={authorization ? authorization.create : true} className="btn btn--base btn--primary" label={'LIST_LAYOUT.CREATE_BUTTON'} onClick={() => routes.create()}></BaasicButton>
            </PageNavigation>
            <Content emptyRenderer={renderEmpty()} >
                <div className='u-mar--bottom--sml'>
                    <TableFilter queryUtility={queryUtility}>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <QueryDropdown
                                queryUtility={queryUtility}
                                store={itemCategoryStore}
                                propertyName="itemCategoryId"
                                label="Category"
                            />
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <BasicQueryInput
                                queryUtility={queryUtility}
                                store={itemIdStore}
                                type="search"
                                propertyName="itemId"
                                label="Item ID"
                            />
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <BasicQueryInput
                                queryUtility={queryUtility}
                                store={itemNameStore}
                                type="search"
                                propertyName="itemName"
                                label="Item Name"
                            />
                        </div>
                        <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group">
                            <QueryDropdown
                                queryUtility={queryUtility}
                                store={procedureCodeStore}
                                propertyName="procedureCodeId"
                                label="Procedure Code"
                            />
                        </div>
                        <div className="col col-sml-6 col-med-6 col-lrg-2 u-flex--self--center u-mar--bottom--tny">
                            <div className="u-flex--primary">
                                <div className="u-mar--right--sml u-mar--bottom--tny">
                                    <BasicQueryCheckbox
                                        id='inactive'
                                        queryUtility={queryUtility}
                                        propertyName='inactive'
                                        label='Show Inactive'
                                        store={inactiveCheckboxStore}
                                        onChange={oninactiveChange}
                                    />
                                </div>
                                <div className="u-mar--bottom--tny">
                                    <BasicQueryCheckbox
                                        id='showpumps'
                                        queryUtility={queryUtility}
                                        propertyName='showpumps'
                                        label='Show Pumps'
                                        store={showPumpsCheckboxStore}
                                        onChange={onShowPumpsChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </TableFilter>
                </div>
                <div className="card--table">
                    <BaasicTable
                        tableStore={tableStore}
                        loading={tableLoading}
                        authorization={authorization}
                        actionsComponent={renderActions}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    )
}

function renderEmpty() {
    return <EmptyState image={EmptyIcon} title='PRODUCT.LIST.EMPTY_STATE.TITLE' description='PRODUCT.LIST.EMPTY_STATE.DESCRIPTION' />
}

ProductListTemplate.propTypes = {
    listViewStore: PropTypes.object
};

function renderActions({ item, actions, authorization }) {
    if (!isSome(actions)) return null;

    const { onEdit, onDelete, onCopy, onPreview } = actions;
    if (!isSome(onEdit) && !isSome(onDelete) && !isSome(onCopy)) return null;

    return (
        <td className="table__body--data right">
            <div className="table__icons">
            {isSome(onPreview) ? (
                    <BaasicButton
                        authorization={authorization ? authorization.read : null}
                        className="btn btn--icon"
                        icon='u-icon u-icon--preview u-icon--sml'
                        label='PRODUCT.LIST.BUTTON.PREVIEW'
                        onlyIcon={true}
                        onClick={() => onPreview(item)}>
                    </BaasicButton>
                ) : null}  
                {isSome(onEdit) ? (
                    <BaasicButton
                        authorization={authorization ? authorization.update : null}
                        className="btn btn--icon"
                        icon='u-icon u-icon--edit u-icon--sml'
                        label='PRODUCT.LIST.BUTTON.EDIT'
                        onlyIcon={true}
                        onClick={() => onEdit(item)}>
                    </BaasicButton>
                ) : null}
                {isSome(onCopy) && authorization && authorization.create ? (
                    <BaasicButton
                        authorization={authorization ? authorization.create : null}
                        className="btn btn--icon"
                        icon='u-icon u-icon--copy u-icon--sml'
                        label='PRODUCT.LIST.BUTTON.COPY'
                        onlyIcon={true}
                        onClick={() => onCopy(item)}>
                    </BaasicButton>
                ) : null}
                {isSome(onDelete) ? (
                    <BaasicButton
                        authorization={authorization ? authorization.delete : null}
                        className="btn btn--icon is-delete"
                        icon='u-icon u-icon--delete u-icon--sml'
                        label='PRODUCT.LIST.BUTTON.DELETE'
                        onlyIcon={true}
                        onClick={() => onDelete(item)}>
                    </BaasicButton>
                ) : null}
            </div>
        </td>
    );

}

renderActions.propTypes = {
    item: PropTypes.any,
    actions: PropTypes.any,
    authorization: PropTypes.any
};

export default defaultTemplate(ProductListTemplate);
